"use client";

import { NAVBAR_HEIGHT } from "@/lib/constants";
import { Link } from "@/i18n/navigation";
import React from "react";
import { Button } from "./ui/button";
import { LanguageSwitcher } from "./LangaugeSelector";
import { useLocale, useTranslations } from "next-intl";
import { Avatar, AvatarFallback, AvatarImage } from "./ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "./ui/dropdown-menu";
import { usePathname, useRouter } from "next/navigation";
import { SidebarTrigger } from "./ui/sidebar";
import { persistor, useAppDispatch, useAppSelector } from "@/state/redux";
import { clearCredentials } from "@/state/slices/authSlice";
import { toast } from "sonner";

function Navbar() {
  const pathname = usePathname();

  const isDashboardPage = pathname.includes("/user");
  const local = useLocale();
  const isAr = local === "ar" ? true : false;
  const router = useRouter();
  const t = useTranslations("NavBar");
  const user = useAppSelector((state) => state.auth.user);
  const dispatch = useAppDispatch();
  return (
    <div
      className="fixed top-0 left-0 w-full z-50 shadow-xl"
      style={{ height: NAVBAR_HEIGHT }}
    >
      <div className="flex justify-between items-center w-full py-3 px-8 bg-primary-700 text-white">
        <div className="flex items-center gap-4 md:gap-6 ">
          {isDashboardPage && (
            <div className="md:hidden">
              <SidebarTrigger />
            </div>
          )}
          <Link
            href="/"
            className="cursor-pointer hover:!text-primary-300"
            scroll={false}
          >
            <div className="flex items-center gap-3">
              {/* <Image
                src={"/logo.svg"}
                alt="OSOUL Logo"
                width={24}
                height={24}
                className="w-6 h-6"
              /> */}
              <div className={`text-xl ${isAr ? "font-light" : "font-black"}`}>
                {t("titFirst")}
                <span
                  className={`text-secondary-500 ${
                    isAr ? "font-black" : "font-light"
                  } hover:!text-primary-300`}
                >
                  {t("titSecond")}
                </span>
              </div>
            </div>
          </Link>
        </div>
        <p className="text-primary-200 hidden md:block">{t("title")}</p>
        <div className="flex items-center gap-5">
          {user ? ( //is auth user?
            <>
              {/* <div className="relative hidden md:block">
                <MessageCircle className="w-6 h-6 cursor-pointer text-primary-200 hover:text-primary-400" />
                <span className="absolute top-0 right-0 w-2 h-2 bg-secondary-700 rounded-full"></span>
              </div>
              <div className="relative hidden md:block">
                <Bell className="w-6 h-6 cursor-pointer text-primary-200 hover:text-primary-400" />
                <span className="absolute top-0 right-0 w-2 h-2 bg-secondary-700 rounded-full"></span>
              </div> */}

              <DropdownMenu>
                <DropdownMenuTrigger className="flex items-center gap-2 focus:outline-none">
                  <Avatar>
                    <AvatarImage src={"/"} />
                    <AvatarFallback className="bg-primary-600 p-2 rounded-full">
                      {isAr
                        ? user?.full_name_ar.slice(0, 1)
                        : user?.full_name_en.slice(0, 1)}
                    </AvatarFallback>
                  </Avatar>
                  <p className="text-primary-200 hidden md:block">
                    {isAr ? user?.full_name_ar : user?.full_name_en}
                  </p>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="bg-white text-primary-700">
                  <DropdownMenuItem
                    className="cursor-pointer hover:!bg-primary-700 hover:!text-primary-100 font-bold"
                    style={{ flexDirection: isAr ? "row-reverse" : "row" }}
                    onClick={() =>
                      router.push("/user/favorite", { scroll: false })
                    }
                  >
                    {t("gotodash")}
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    style={{ flexDirection: isAr ? "row-reverse" : "row" }}
                    className="cursor-pointer hover:!bg-primary-700 hover:!text-primary-100"
                    onClick={() => {
                      router.push("/search", { scroll: false });
                    }}
                  >
                    {t("Search")}
                  </DropdownMenuItem>
                  <DropdownMenuSeparator className="bg-primary-200" />
                  <DropdownMenuItem
                    style={{ flexDirection: isAr ? "row-reverse" : "row" }}
                    className="cursor-pointer hover:!bg-primary-700 hover:!text-primary-100"
                    onClick={() =>
                      router.push(`/user/setting`, { scroll: false })
                    }
                  >
                    {t("Settings")}
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    style={{ flexDirection: isAr ? "row-reverse" : "row" }}
                    className="cursor-pointer hover:!bg-primary-700 hover:!text-primary-100"
                    onClick={async () => {
                      dispatch(clearCredentials());
                      persistor.purge();
                      await toast.success("Logged out succesfully");
                    }}
                  >
                    {t("Signout")}
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </>
          ) : (
            <>
              <LanguageSwitcher />

              <Link href="/signin">
                <Button
                  variant="outline"
                  className="text-white border-white bg-transparent hover:bg-white hover:text-primary-700 rounded-lg"
                >
                  {t("signIn")}
                </Button>
              </Link>
              <Link href="/signup">
                <Button
                  variant="secondary"
                  className="text-white bg-secondary-600 hover:bg-white hover:text-primary-700 rounded-lg"
                >
                  {t("signUp")}
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Navbar;
